<template>
	<div class="login-container">
		<div class="login-card">
			<div class="login-brand">
				<img class="brand-logo" :src="logo" alt="宝太脑健康">
				<div class="brand-text">
					<h1>宝太脑健康</h1>
					<span class="brand-en">Brain Health Management</span>
				</div>
			</div>

			<div class="login-divider"></div>

			<div class="login-header">
				<h2>欢迎登录</h2>
				<p>请使用管理员账号登录后台管理系统</p>
			</div>

			<el-form :model="loginForm" :rules="loginRules" ref="loginForm" class="login-form-content">
				<el-form-item prop="username">
					<el-input v-model="loginForm.username" placeholder="请输入用户名" prefix-icon="el-icon-user"
						size="medium"></el-input>
				</el-form-item>

				<el-form-item prop="password">
					<el-input v-model="loginForm.password" type="password" placeholder="请输入密码"
						prefix-icon="el-icon-lock" size="medium" @keyup.enter.native="handleLogin"></el-input>
				</el-form-item>

				<el-form-item class="login-submit">
					<el-button type="primary" size="medium" :loading="loading" @click="handleLogin" style="width: 100%">
						登 录
					</el-button>
				</el-form-item>
			</el-form>

			<div class="login-footer">
				<p>© 2026 宝太脑健康管理系统</p>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		authAPI
	} from '@/services/api'
	import logo from '@/assets/biotime_logo.png'

	export default {
		name: 'Login',
		data() {
			return {
				logo,
				loginForm: {
					username: '',
					password: ''
				},
				loginRules: {
					username: [{
						required: true,
						message: '请输入用户名',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}]
				},
				loading: false
			}
		},
		methods: {
			async handleLogin() {
				// 防止重复提交
				if (this.loading) {
					return
				}

				this.$refs.loginForm.validate(async (valid) => {
					if (valid) {
						this.loading = true
						try {
							const response = await authAPI.login(this.loginForm)

							this.$store.dispatch('login', {
								token: response.token,
								userInfo: response.userInfo
							})

							this.$message.success('登录成功')
							// 直接跳仪表盘：跳 '/' 会被路由的 redirect 再转一次，
							// 多产生一次重定向（守卫重定向在 vue-router 3.x 里表现为 rejected Promise）
							this.$router.push('/dashboard').catch(err => {
								// 导航失败（重定向/重复/取消）静默处理，其余异常才提示
								if (!(err && err._isRouter)) {
									console.error('跳转失败:', err)
								}
							})
						} catch (error) {
							console.error('登录失败:', error)
							this.$message.error(error.message || '登录失败，请检查用户名和密码')
						} finally {
							this.loading = false
						}
					}
				})
			}
		}
	}
</script>

<style scoped>
	/* 背景全部由 CSS 渐变绘制，不使用任何图片或动画，
	   刷新时无需等待资源加载，不会出现缓冲/闪白 */
	.login-container {
		position: relative;
		min-height: 100vh;
		padding: 48px 20px;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #0d2233;
		background-image:
			radial-gradient(900px 520px at 12% 12%, rgba(22, 96, 136, 0.45), transparent 62%),
			radial-gradient(820px 620px at 88% 88%, rgba(36, 150, 199, 0.26), transparent 62%),
			linear-gradient(155deg, #0a1a28 0%, #0f2a3d 45%, #123246 100%);
	}

	/* 极细斜纹肌理，增加质感，纯 CSS 无资源加载 */
	.login-container::before {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background-image: repeating-linear-gradient(135deg, rgba(255, 255, 255, 0.025) 0 1px, transparent 1px 7px);
		pointer-events: none;
	}

	.login-card {
		position: relative;
		z-index: 1;
		width: 420px;
		max-width: 100%;
		background: #fff;
		border-radius: 14px;
		padding: 46px 44px 28px;
		box-shadow: 0 30px 70px rgba(3, 18, 30, 0.45);
	}

	/* 顶部品牌色细条 */
	.login-card::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 4px;
		border-radius: 14px 14px 0 0;
		background: linear-gradient(90deg, #166088 0%, #2496c7 60%, #6fc0e0 100%);
	}

	.login-brand {
		display: flex;
		align-items: center;
	}

	.brand-logo {
		width: 84px;
		height: 84px;
		object-fit: contain;
		display: block;
	}

	.brand-text {
		margin-left: 18px;
	}

	.brand-text h1 {
		margin: 0;
		font-size: 20px;
		font-weight: 600;
		color: #12222f;
		letter-spacing: 2px;
	}

	.brand-en {
		display: block;
		margin-top: 5px;
		font-size: 10px;
		letter-spacing: 2px;
		color: #9aa7b4;
		text-transform: uppercase;
	}

	.login-divider {
		height: 1px;
		background: #eef1f5;
		margin: 24px 0 26px;
	}

	.login-header {
		margin-bottom: 24px;
	}

	.login-header h2 {
		margin: 0 0 6px;
		color: #12222f;
		font-size: 16px;
		font-weight: 600;
	}

	.login-header p {
		color: #8b98a6;
		font-size: 13px;
	}

	.login-form-content ::v-deep .el-form-item {
		margin-bottom: 20px;
	}

	.login-form-content ::v-deep .el-input__inner {
		height: 46px;
		line-height: 46px;
		border: 1px solid #dfe4ea;
		background: #fbfcfd;
		font-size: 14px;
		color: #2c3e50;
	}

	.login-form-content ::v-deep .el-input__inner:focus {
		border-color: #166088;
		background: #fff;
	}

	.login-form-content ::v-deep .el-input__icon {
		line-height: 46px;
		color: #9aa7b4;
	}

	.login-submit {
		margin-top: 4px;
	}

	.login-form-content ::v-deep .el-button--primary {
		height: 46px;
		font-size: 15px;
		letter-spacing: 6px;
		border: none;
		background-color: #166088;
		box-shadow: 0 10px 22px rgba(22, 96, 136, 0.25);
	}

	.login-form-content ::v-deep .el-button--primary:hover,
	.login-form-content ::v-deep .el-button--primary:focus {
		background-color: #14577c;
	}

	.login-footer {
		margin-top: 24px;
		padding-top: 16px;
		border-top: 1px solid #eef1f5;
		text-align: center;
	}

	.login-footer p {
		color: #a5b0bc;
		font-size: 12px;
		letter-spacing: 0.5px;
	}
</style>